import { Loading, QSpinnerBall } from 'quasar'

const loadingToggle = state => {
  switch (state) {
    case true:
      Loading.show({
        spinner: QSpinnerBall,
        backgroundColor: 'white',
        spinnerColor: 'primary'
      })
      break

    case false:
      Loading.hide()
      break
  }
}

export { loadingToggle }
